import AppHeader from "@saleor/components/AppHeader";
import CardSpacer from "@saleor/components/CardSpacer";
import Container from "@saleor/components/Container";
import LanguageSwitch from "@saleor/components/LanguageSwitch";
import PageHeader from "@saleor/components/PageHeader";
import { ShippingMethodTranslationFragment } from "@saleor/fragments/types/ShippingMethodTranslationFragment";
import { commonMessages, sectionNames } from "@saleor/intl";
import { TranslationsEntitiesPageProps } from "@saleor/translations/types";
import React from "react";
import { useIntl } from "react-intl";

import { maybe } from "../../../misc";
import { LanguageCodeEnum } from "../../../types/globalTypes";
import TranslationFields from "../TranslationFields";

export interface TranslationsShippingMethodPageProps
  extends TranslationsEntitiesPageProps {
  shippingMethod: ShippingMethodTranslationFragment;
}

export const fieldNames = {
  name: "name",
  instructions: "instructions"
};

const TranslationsShippingMethodPage: React.FC<TranslationsShippingMethodPageProps> = ({
  activeField,
  disabled,
  languageCode,
  languages,
  shippingMethod,
  saveButtonState,
  onBack,
  onDiscard,
  onEdit,
  onLanguageChange,
  onSubmit
}) => {
  const intl = useIntl();

  return (
    <Container>
      <AppHeader onBack={onBack}>
        {intl.formatMessage(sectionNames.translations)}
      </AppHeader>
      <PageHeader
        title={intl.formatMessage(
          {
            defaultMessage:
              'Translation Menu Item "{shippingMethodName}" - {languageCode}',
            description: "header"
          },
          {
            languageCode,
            shippingMethodName: maybe(() => shippingMethod.name, "...")
          }
        )}
      >
        <LanguageSwitch
          currentLanguage={LanguageCodeEnum[languageCode]}
          languages={languages}
          onLanguageChange={onLanguageChange}
        />
      </PageHeader>
      <TranslationFields
        activeField={activeField}
        disabled={disabled}
        initialState={true}
        title={intl.formatMessage(commonMessages.generalInformations)}
        fields={[
          {
            displayName: intl.formatMessage({
              defaultMessage: "Menu Item Name"
            }),
            name: fieldNames.name,
            translation: maybe(() =>
              shippingMethod.translation
                ? shippingMethod.translation.name
                : null
            ),
            type: "short" as "short",
            value: maybe(() => shippingMethod.name)
          },
          {
            displayName: intl.formatMessage({
              defaultMessage: "Menu Item Url",
              description: "shippingMethod content"
            }),
            name: fieldNames.instructions,
            translation: maybe(() =>
              shippingMethod.translation
                ? shippingMethod.translation.instructions
                : null
            ),
            type: "long" as "long",
            value: maybe(() => shippingMethod.instructions)
          }
        ]}
        saveButtonState={saveButtonState}
        onEdit={onEdit}
        onDiscard={onDiscard}
        onSubmit={onSubmit}
      />
      <CardSpacer />
    </Container>
  );
};
TranslationsShippingMethodPage.displayName = "TranslationsShippingMethodPage";
export default TranslationsShippingMethodPage;
